import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainHeaderComponent } from './main-header/main-header.component';
import { MainNavComponent } from './main-nav/main-nav.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { UserMenuComponent } from './main-header/user-menu/user-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OpendialogDeleteAllRecordsComponent } from './opendialog-delete-all-records/opendialog-delete-all-records.component';
import { ValidationAnimationComponent } from './validation-animation/validation-animation.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FontAwesomeModule

  ],
  declarations: [
    MainHeaderComponent,
    MainNavComponent,
    UserMenuComponent,
    OpendialogDeleteAllRecordsComponent,
    ValidationAnimationComponent


  ],
  exports: [
    MainHeaderComponent,
    MainNavComponent,
    UserMenuComponent,
    OpendialogDeleteAllRecordsComponent,
    ValidationAnimationComponent


  ]
})
export class MainModule { }
